import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';
import codes from '../utils/constants/codes';

export interface GeneralResponse {
    data: GeneralResponseBody;
}
export interface GeneralResponseBody {
    data: Array<Questions>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}

export interface Questions {
    id: string;
    code: string;
    name: string;
    groupShape: boolean;
}

export interface QuestionPayload {
    claimApplicationId: string;
    claimCategoryCode: string;
    claimTypeCode: string;
    policyTypeCode: string;
    groupCode: string;
    questionGroupStepId: string;
}
export interface QuestionGroupPayload {
    claimApplicationId: string;
    groupCode: string;
}
export interface QuestionSurveyPayload {
    claimApplicationId: string;
    surveyTypeId: string;
}

export const fetchQuestions = createAction<fetchQuestionsAction>(
    ActionTypes.FETCH_QUESTIONS,
);
export const fetchQuestionsSuccess = createAction<fetchQuestionsSuccessAction>(
    ActionTypes.FETCH_QUESTIONS_SUCCESS,
);
export const fetchQuestionsFailed = createAction<fetchQuestionsFailedAction>(
    ActionTypes.FETCH_QUESTIONS_FAILED,
);
export const clearQuestionState = createAction<
    clearQuestionStateAction | undefined
>(ActionTypes.CLEAR_QUESTION_STATE);
export const fetchAllQuestions = createAction<fetchAllQuestionsAction>(
    ActionTypes.FETCH_ALL_QUESTIONS,
);
export const fetchAllQuestionsSuccess =
    createAction<fetchAllQuestionsSuccessAction>(
        ActionTypes.FETCH_ALL_QUESTIONS_SUCCESS,
    );
export const fetchAllQuestionsFailed =
    createAction<fetchAllQuestionsFailedAction>(
        ActionTypes.FETCH_ALL_QUESTIONS_FAILED,
    );
export const fetchQuestionsOfClaimTypeCombo =
    createAction<fetchQuestionsOfClaimTypeComboAction>(
        ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO,
    );
export const fetchQuestionsOfClaimTypeComboSuccess =
    createAction<fetchQuestionsOfClaimTypeComboSuccessAction>(
        ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_SUCCESS,
    );
export const fetchQuestionsOfClaimTypeComboFailed =
    createAction<fetchQuestionsOfClaimTypeComboFailedAction>(
        ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_FAILED,
    );
export const fetchQuestionsByGroup = createAction<fetchQuestionsByGroupAction>(
    ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP,
);
export const fetchQuestionsByGroupSuccess =
    createAction<fetchQuestionsByGroupSuccessAction>(
        ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP_SUCCESS,
    );
export const fetchQuestionsByGroupFailed =
    createAction<fetchQuestionsByGroupFailedAction>(
        ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP_FAILED,
    );

export interface fetchQuestionsAction {
    type?: typeof ActionTypes.FETCH_QUESTIONS;
    policyTypeCode: string;
    claimCategoryCode: string;
    formTypeCode: string;
    questionGroupStepId: string;
}

export interface fetchQuestionsSuccessAction {
    type: typeof ActionTypes.FETCH_QUESTIONS_SUCCESS;
    body: GeneralResponse;
}

export interface fetchQuestionsFailedAction {
    type: typeof ActionTypes.FETCH_QUESTIONS_FAILED;
    payload: GeneralResponse;
}

export interface clearQuestionStateAction {
    type?: typeof ActionTypes.CLEAR_QUESTION_STATE;
    payload: null;
}

export interface fetchAllQuestionsAction {
    type: typeof ActionTypes.FETCH_ALL_QUESTIONS;
    payload: QuestionPayload;
}

export interface fetchAllQuestionsSuccessAction {
    type: typeof ActionTypes.FETCH_ALL_QUESTIONS_SUCCESS;
    body: GeneralResponse;
}

export interface fetchAllQuestionsFailedAction {
    type: typeof ActionTypes.FETCH_ALL_QUESTIONS_FAILED;
    payload: GeneralResponse | any;
}
export interface fetchQuestionsOfClaimTypeComboAction {
    type?: typeof ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO;
    policyTypeCode: string | null;
    claimCategoryCode: string | null;
    formTypeCode: string | null;
    claimApplicationId: string;
}
export interface fetchQuestionsOfClaimTypeComboSuccessAction {
    type: typeof ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_SUCCESS;
    body: GeneralResponse;
}

export interface fetchQuestionsOfClaimTypeComboFailedAction {
    type: typeof ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_FAILED;
    payload: GeneralResponse;
}
export interface fetchQuestionsByGroupAction {
    type: typeof ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP;
    payload: QuestionPayload;
}

export interface fetchQuestionsByGroupSuccessAction {
    type: typeof ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP_SUCCESS;
    body: GeneralResponse;
}

export interface fetchQuestionsByGroupFailedAction {
    type: typeof ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP_FAILED;
    payload: GeneralResponse;
}
